import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/84c6b5b2007827379fdc91867b7404ab.jpg"
          alt="Horn Property Maintenance - Quality Home Services Burlington Ontario"
          className="w-full h-full object-cover object-top"
          width="1920"
          height="900"
          fetchpriority="high"
          decoding="async"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/50"></div>
      </div>

      {/* Hero Content – right aligned */}
      <div className="relative z-10 w-full flex justify-end px-6 lg:px-24">
        <div
          className={`max-w-xl text-right transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-[#C8A97E] text-xs font-bold tracking-[0.4em] uppercase mb-4">
            WELCOME
          </p>
          <h1
            className="text-white text-5xl lg:text-6xl font-bold leading-tight mb-5"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Building Trust<br />
            with Quality<br />
            Work
          </h1>
          <p className="text-white/80 text-lg mb-8 font-light">
            We'll get the job done.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-end">
            <a
              href="#contact"
              className="bg-[#2B5741] text-white px-7 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#3A7060] transition-colors whitespace-nowrap"
            >
              GET A FREE ESTIMATE
            </a>
            <a
              href="#projects"
              className="border-2 border-white text-white px-7 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white hover:text-[#2B5741] transition-colors whitespace-nowrap"
            >
              RECENT WORK
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-5 h-8 flex items-center justify-center border-2 border-white/50 rounded-full">
          <div className="w-1 h-2 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
